import _ from "lodash";
import React, { useState, useEffect, useCallback, useRef } from "react";
import data from "../../assets/apiRoutes.json";
import axios from "axios";
import { SelectBox } from "devextreme-react/select-box";
import { TextBox } from 'devextreme-react/text-box';
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import RadioGroup from 'devextreme-react/radio-group';
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import debounce from "lodash/debounce";
import FileUploader from "devextreme-react/file-uploader";
import {alert} from 'devextreme/ui/dialog';
import { GetDateTimeStandardFormat } from "../../common/Utils";
import { TwoFactorAuthenticationSetting } from '../../enum/Enum';

import {
  Validator,
  RequiredRule,
  CompareRule,
  EmailRule,
  PatternRule,
  StringLengthRule,
  RangeRule,
  AsyncRule,
} from 'devextreme-react/validator';
import { Button, Popup, Switch } from "devextreme-react";
const AddEditUser = (props) => {
  const selectBox = useRef(null);
  const history = useHistory();
  const { location } = props;
  const access_token = props.oidc.user.access_token;
  const [openUserDialog, setOpenUserDialog] = useState(true);
  const [userExistsError, setUserExistsError] = useState("");
  const [noCompanySelectedError, setNoCompanySelectedError] = useState("");
  const [userExists, setUserExists] = useState(false);
  const [userEmailExistsError, setUserEmailExistsError] = useState("");
  const [userEmailExists, setUserEmailExists] = useState(false);
  const [userLockoutEnd, setUserLockoutEnd] = useState(location?.user?.lockoutEnd ? true : false);
  const [identityIdClaim, setIdentityIdClaim] = useState(
    location?.user?.identityId
  );
  const [userCompanyIdsClaim, setUserCompanyIdsClaim] = useState(
    location?.user?.userCompanyIds
  );
  const [twoFASetting, setTwoFASetting] = useState(location?.user?.twoFASetting ? location?.user?.twoFASetting : "");
  const [twoFAExpirationDateTime, setTwoFAExpirationDateTime] = useState(location?.user?.twoFAExpirationDateTime ? location?.user?.twoFAExpirationDateTime : "");

  const [userModel, setUserModel] = useState(location.user);
    const twoFASettings = [
        { id: "", text: 'Default' },
        { id: TwoFactorAuthenticationSetting.NotRequiredForNextLogin, text: TwoFactorAuthenticationSetting.NotRequiredForNextLoginText },
        { id: TwoFactorAuthenticationSetting.NotRequiredFor24Hours, text: TwoFactorAuthenticationSetting.NotRequiredFor24HoursText },
  ];
  const [databaseCompanies, setDatabaseCompanies] = useState([]);
  const [title, setTitle] = useState("Add/Edit User");
  const [imageBase64, setImageBase64] = useState("");
  const arrayUnion = (arr1, arr2, identifier) => {
    const array = [...arr1, ...arr2];

    return _.uniqBy(array, identifier);
  };


  const [addUserRequest, setAddUserRequest] = useState({
    userName: userModel?.userName,
    email: userModel?.email,
    password: "",
    confirmPassword: "",
    id: userModel?.id,
    lockoutEnd:null,
  });
  const saveUserInIdp = (userRequest) => {
    let url = '';
    if (userRequest.id === "" || userRequest.id === undefined) {
      url = `${window._env_.REACT_APP_AUTH_URL}/${data.idp.addUser}`
    } else {
      url = `${window._env_.REACT_APP_AUTH_URL}/${data.idp.editUser}`
    }

    axios
      .post(
        url,
        userRequest
      )
      .then((res) => {
        if (res.data.errors.length > 0) {
          const uniqueItems = removeDuplicateErrors(res.data.errors);
          setUserErrors(uniqueItems)
        }
        else {
          props.loadIdpUsers();
          resetClaims();
          setOpenUserDialog(false);
          history.push("/security/user-security");
        }

      })
      .catch((err) => {
        console.log(err, "error in loading Roles");
        history.push("/security/user-security");
      });

  };

  const onInputChange = (e) => {
    if (e.element.id === "password") {
      setAddUserRequest({ ...addUserRequest, ["password"]: e.value });
    }
    if (e.element.id === "confirmPassword") {
      setAddUserRequest({ ...addUserRequest, ["confirmPassword"]: e.value });
    }
    if (e.element.id === "confirmPassword") {
      if (e.value === addUserRequest.password) {
        setConfirmPwdError(false);
      } else {
        setConfirmPwdError(true);
      }
    }
  };
  const removeDuplicateErrors = (data) => {
    const uniqueCodes = new Set();
    return data.filter(item => {
      if (!uniqueCodes.has(item.Code)) {
        uniqueCodes.add(item.Code);
        return true;
      }
      return false;
    });
  };
  const checkUserNameExists = async (e) => {

    let userName = e.value;
    if (userName !== "") {
      let response = await axios.get(
        `${window._env_.REACT_APP_AUTH_URL}/${data.idp.checkUserExists}?username=${userName}`
      );
      if (response.data == true) {
        setUserExistsError(`${userName} already exists.`);
        setUserExists(true);
      } else {
        setUserExistsError("");
        setUserExists(false);
      }
    } else {

      setUserExists(false);
      setUserExistsError("");
    }
  };
  const debouncedUserCheck = debounce(async (e) => {
    if (addUserRequest.id !== undefined && addUserRequest.userName !== userModel?.userName) {
      await checkUserNameExists(e);
    } else if (addUserRequest.id === undefined) {
      await checkUserNameExists(e);
    }
  }, 4000);
  const onChangingUserName = (e) => {
    setAddUserRequest({ ...addUserRequest, ["userName"]: e.value });
    debouncedUserCheck(e);
  };
  const onChangingUserEmail = (e) => {
    setAddUserRequest({ ...addUserRequest, ["email"]: e.value });
  };
  const loadIdentityIdLookup = (key) => {
    let request = { identityIdTerm: key };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.IdInfoWebUsers.loadIdentityIdLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: access_token,
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        var identityDataStore = new DataSource({
          store: new ArrayStore({
            data: response.data.identityIdLookups
          }),
          paginate: true,
          pageSize: 100
        });

        selectBox.current.instance().option(
          "dataSource",
          identityDataStore
        );

        selectBox.current.instance().option(
          "acceptCustomValue",
          false
        );
      })
      .catch((err) => {
        console.log(err, "Error in loading users");
      });
  };
  useEffect(() => {
    loadIdentityIdLookup("");
    if (location.user !== null && location.user !== undefined &&
      props.databaseInfo !== null && props.databaseInfo !== undefined &&
      props.databaseInfo !== null && props.databaseInfo !== undefined &&
      location.user.userCompanyIds !== null && location.user.userCompanyIds !== undefined && location.user.userCompanyIds.value!==null) {
      let newArray = [];
      props.databaseInfo.map((c) => {
        location.user.userCompanyIds.value.split(',').map((cc) => {
          if (c.value == cc) {
            c.checked = true;
          }
          return cc;
        });
        newArray.push(c);
        return c;
      });
      setDatabaseCompanies(newArray);
    }
    else {
      setDatabaseCompanies(props.databaseInfo);
    }
  }, []);

  const resetClaims = () => {
    props.databaseInfo.map((cc) => {
      cc.checked = false;
    });
    resetErrors();
  };
  const resetErrors = () => {
    setUserExistsError("");
    setUserEmailExistsError("");
    setNoCompanySelectedError("");
  };
  const selectDatabaseCompanies = (e) => {

    var userCompanyIdsClaimvalue = "";
    var data = databaseCompanies.map((cc) => {
      if (cc.value == e.target.value) {
        cc.checked = e.target.checked;
      }

      if (cc.checked) {
        if (userCompanyIdsClaimvalue === "") {
          userCompanyIdsClaimvalue = cc.value;
        }
        else {
          userCompanyIdsClaimvalue = userCompanyIdsClaimvalue + "," + cc.value;
        }

      }
      return cc;
    });

    let userCompanyIdsClaimType = {
      type: "UserCompanyIds",
      value: userCompanyIdsClaimvalue,
    };
    setUserCompanyIdsClaim(userCompanyIdsClaimType);
  };
  const [confirmPwdError, setConfirmPwdError] = useState(false);
  const [userErrors, setUserErrors] = useState([]);
  const addUser = (e) => {
    e.preventDefault();

    if (userCompanyIdsClaim == null || userCompanyIdsClaim == undefined || 
        userCompanyIdsClaim.value == null || userCompanyIdsClaim.value == undefined || userCompanyIdsClaim.value == "")
    {
      setNoCompanySelectedError("Please select at least one company");
      return;
    }
    else
    {
      setNoCompanySelectedError("");
    }

    let claims = arrayUnion(
      [
        {
          type: "scope",
          value: "resourceApi",
        },
        {
          type: "scope",
          value: "openid",
        },
        {
          type: "scope",
          value: "profile",
        },
      ],
      [],
      "value"
    );

    claims.push(identityIdClaim);
    claims.push(userCompanyIdsClaim);
   

    if(twoFASetting && twoFASetting != "") {
      claims.push({
        type: TwoFactorAuthenticationSetting.TwoFASetting,
        value: twoFASetting,
      });
    }

    if (twoFASetting == TwoFactorAuthenticationSetting.NotRequiredFor24Hours && twoFAExpirationDateTime && twoFAExpirationDateTime != "") {
      claims.push({
        type: TwoFactorAuthenticationSetting.TwoFAExpirationDateTime,
        value: twoFAExpirationDateTime,
      });
    }

    var userRequestForAdd = {
      userName: addUserRequest.userName,
      password: addUserRequest.password,
      id: userModel?.id,
      email: addUserRequest.email,
      claims: claims,
      userImageBase64: imageBase64,
      lockoutEnd:addUserRequest.lockoutEnd,
    };

    if (userExists) {
      setUserExistsError("Please choose different user name");
    } else if (addUserRequest.password !== addUserRequest.confirmPassword) {
      setConfirmPwdError(true);
    }
    else if (userEmailExists) {
      setUserEmailExistsError("Please choose different user email");
    } else {
      saveUserInIdp(userRequestForAdd);
    }
  };
  const onIdentityIdChange = (identityId) => {
    let identityClaimType = {
      type: "identityId",
      value: identityId,
    };
    setIdentityIdClaim(identityClaimType);
  };
  
  const handleFileChange = (e) => {
    const file = e.value[0];
    if (file) {
        if (file.size > 3 * 1024 * 1024) {
            alert("Image size should not exceed 3MB.","Error");
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(",")[1]; // Remove metadata part
            setImageBase64(base64String);
        };
        reader.onerror = () => {
          alert("Error reading file.");
      };
    }
};
  const lockOutChange = (e) => {
    if(e.value===true){
      const maxDate = new Date(9999, 11, 31, 23, 59, 59);
      setAddUserRequest({ ...addUserRequest, ["lockoutEnd"]: maxDate.toISOString() });
    }
    else{
      setAddUserRequest({ ...addUserRequest, ["lockoutEnd"]: null });
    }
    setUserLockoutEnd(e.value);
  };
  return (
    <>
      <div>
        <Popup
          visible={openUserDialog}
          onHiding={()=>setOpenUserDialog(false)}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={false}
          showTitle={true}
          title={title}
          container="#root"
          height='auto'
          width={800}
        >
          <div className="row addEdit-dialog">
            <div className="col-md-6">
              <form onSubmit={(e) => addUser(e)}>
                <div className="col-md-12">
                  <TextBox
                    id="userName"
                    label=" User Name"
                    labelMode="static"
                    stylingMode='outlined'
                    name="userName"
                    value={addUserRequest.userName}
                    onValueChanged={(e) => onChangingUserName(e)}
                  />
                  <span className="error-span">{userExistsError}</span>
                </div>
                <div className="col-md-12">
                  <TextBox
                    id="email"
                    label="Enter Email"
                    labelMode="static"
                    stylingMode='outlined'
                    onValueChanged={(e) => onChangingUserEmail(e)}
                    name="email"
                    mode="text"
                    value={addUserRequest.email}
                  >
                    <Validator>
                      <RequiredRule message="Email is required" />
                      <EmailRule message="Email is invalid" />
                     <AsyncRule
                        message="Email is already registered"
                        validationCallback={asyncValidation} />
                    </Validator>
                  </TextBox>
                  <span className="error-span">{userEmailExistsError}</span>
                </div>
                {userModel != undefined && userModel.id != "" ? (
                  ""
                ) : (
                  <div className="col-md-12">

                    <TextBox
                      id="password"
                      label="Enter Password"
                      labelMode="static"
                      stylingMode='outlined'
                      onValueChanged={(e) => onInputChange(e)}
                      value={addUserRequest.password}
                      name="password"
                      mode="password"
                    >
                      <Validator>
                        <RequiredRule message="Password is required" />
                      </Validator>
                    </TextBox>
                    <span className="error-span"></span>
                  </div>
                )}

                {userModel != undefined && userModel.id != "" ? (
                  ""
                ) : (
                  <div className="col-md-12">
                    <TextBox
                     id="confirmPassword"
                      label="Confirm Password"
                      labelMode="static"
                      stylingMode='outlined'
                      onValueChanged={(e) => onInputChange(e)}
                      name="confirmPassword"
                      mode="password"
                      value={addUserRequest.confirmPassword}>
                      <Validator>
                        <RequiredRule message="Password is required" />
                      </Validator>
                    </TextBox>
                    <span className="error-span">{confirmPwdError ? 'Password does not match':''}</span>
                  </div>
                )}
                <div className="col-md-12">
                  <SelectBox
                    ref={selectBox}
                    searchEnabled={true}
                    label="Select Identity ID"
                    labelMode="static"
                    stylingMode='outlined'
                    displayExpr="displayText"
                    valueExpr="value"
                    acceptCustomValue={true}
                    /* dataSource={IdentityIdDataSource} */
                    defaultValue={userModel?.identityId?.value}
                    onValueChange={(e) => onIdentityIdChange(e)}
                  />
                </div>
                <div className="fileuploader-container">
                  <div className="col-md-12">
                    <FileUploader
                      selectButtonText="Select Image"
                      labelText="Max 3MB"
                      uploadMode="useForm"
                      accept="image/*"
                      maxFileSize={3 * 1024 * 1024}
                      onValueChanged={handleFileChange}
                    />
                    {userModel?.userImage ?
                      (<img src={`data:image/png;base64,${userModel?.userImage}`} className="user-image" alt="User" />) :
                      (<></>)}
                  </div>
                </div>
                <div>
                <div className="dx-fieldset">
                  <div className="dx-field">
                    <div className="dx-field-label">Account Locked</div>
                    <div className="dx-field-value" style={{width:"0px"}}>
                      <Switch value={userLockoutEnd} onValueChanged={lockOutChange}/>
                    </div>
                  </div>
                </div>
                </div>

                <ul>
                  {userErrors.map((item, index) => (
                    <li key={index}><span className="error-span"> {item.description}</span> </li>
                  ))}
                </ul>
                <div className="row">
                <div className="col-md-12">
                  <Button text="Save User" type="default" useSubmitBehavior={true} />
                  <Button
                   style={{marginLeft:"12px"}}
                    onClick={() => {
                      setOpenUserDialog(false);
                      resetClaims();
                      history.push("/security/user-security");
                    }}
                    text="Cancel"
                  />
                </div>
                </div>
              </form>
            </div>
            <div className="col-md-6">
              <div className="company-wrapper">
                {databaseCompanies?.length > 0 &&
                  databaseCompanies?.map((c, i) => (
                    <div className="company-item" key={i}>
                      <input
                        onChange={selectDatabaseCompanies}
                        type="checkbox"
                        name="databaseCompany"
                        checked={c.checked}
                        value={c.value}
                      />{" "}
                      <span>{c.text}</span>
                    </div>
                  ))}
              </div>
              <span className="error-span">{noCompanySelectedError}</span>
              <div>
                  <fieldset className='col-fieldset' style={{ marginTop: '10px' }} >
                    <legend className="list-title" >Two-Factor Authentication</legend>
                      <RadioGroup
                        items={twoFASettings}
                        defaultValue=""
                        value={twoFASetting}
                        valueExpr="id"
                        displayExpr="text"
                        onValueChanged={e => {
                            setTwoFASetting(e.value);
                            if(e.value == TwoFactorAuthenticationSetting.NotRequiredFor24Hours)
                            { 
                              var currentDate = new Date();
                              setTwoFAExpirationDateTime(GetDateTimeStandardFormat(currentDate.setHours(currentDate.getHours() + 24)));
                            }
                        }}
                      />
                      <div style={{display: twoFASetting == TwoFactorAuthenticationSetting.NotRequiredFor24Hours ? 'block' : 'none'}}>
                        <span style={{
                          marginLeft: '30px',
                          marginRight: '20px',
                        }}>{twoFAExpirationDateTime ? twoFAExpirationDateTime : ''}</span>
                          <Button text="Reset" useSubmitBehavior={false} onClick={(e) => {
                              var currentDate = new Date();
                              setTwoFAExpirationDateTime(GetDateTimeStandardFormat(currentDate.setHours(currentDate.getHours() + 24)));
                            }} />
                       </div>

                  </fieldset>
              </div>
            </div>
          </div>
        </Popup>
      </div>
    </>
  );

  function sendRequest(value) {
    return axios.get(
      `${window._env_.REACT_APP_AUTH_URL}/${data.idp.checkUserEmailExists}?userEmail=${value}`
    );
  };
  function asyncValidation(params) {
    if(userModel != undefined && userModel.id != ""){
      setUserEmailExistsError("");
      setUserEmailExists(false);
      return Promise.resolve(true);
    }
    return sendRequest(params.value).then((response) => {
      if (response.data == true) {
        setUserEmailExistsError(`${params.value} already exists.`);
        setUserEmailExists(true);
      } else {
        setUserEmailExistsError("");
        setUserEmailExists(false);
      }
    });
  };
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
    databaseInfo: state.databaseCompaniesReducer.databaseInfo,
  };
}

export default connect(mapStateToProps)(AddEditUser);
